import { render } from "./FormDivider.vue?vue&type=template&id=14be2356&ts=true"
import script from "./FormDivider.vue?vue&type=script&lang=ts"
export * from "./FormDivider.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__